// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"333063bf","453":"d4ff5ebf","455":"a0705714","977":"e055c16b"}[chunkId] + ".chunk.js";
};